import React from 'react'
import { HeadFC } from 'gatsby'

import { ArtisanDefaultSeo } from '..'
import ArtisanLayout from '@src/components/Artisan/ArtisanLayout'
import ArtisanArticleList from '@src/components/Artisan/ArtisanArticlesList'
import { useTranslation } from '@models/Translation'
import { useArtisanArticles } from '@models/Artisan'

import * as style from './style.module.sass'

const ArtisanArticlesPage: React.FC = () => {
  const { locale } = useTranslation()
  const artisanArticles = useArtisanArticles()

  return (
    <ArtisanLayout>
      <section className={style.latest}>
        <div className={style.latestInner}>
          <h1>Latest Articles</h1>
          {locale === 'ja' && <div className={style.label}>新着記事一覧</div>}

          <div className={style.articles}>
            <ArtisanArticleList
              articles={artisanArticles}
              gtmClickType="artisan-all"
            />
          </div>
        </div>
      </section>
    </ArtisanLayout>
  )
}

export const Head: HeadFC = ({ location }) => (
  <ArtisanDefaultSeo title="Artisan Articles" pathName={location.pathname} />
)

export default ArtisanArticlesPage
